export default __webpack_public_path__ + "static/media/Financial-Dashboard.a1010be7.svg";